<template>
  <RunningCard>
    <template #header>
      <div class="running-waiting-header">
        <img src="../../../assets/img-v2/ic_running_clock.png" class="icon" />
        <div class="right">
          <template v-if="isTimeoutArrive">
            <div>
              <span class="status">车辆已到站</span>
              <span class="desc">
                <span>车辆已超时等候</span>
              </span>
            </div>
            <div class="subtitle">订单将可能被司机无责结束</div>
          </template>
          <template v-else-if="isArrive">
            <div>
              <span class="status">车辆已到站</span>
              <span class="desc">
                <span>倒计时</span>
                <span class="blue-num">{{ countdownTime }}</span>
              </span>
            </div>
            <div class="subtitle">
              <span class="blue-text">倒计时结束</span>
              <span>司机可无责取消订单</span>
            </div>
          </template>
          <template v-else>
            <div>
              <span class="status">{{ isNear ? "即将到站" : "未上车" }}</span>
              <span v-if="onTime" class="desc">
                <span>预计</span>
                <span class="blue-num">{{ onTime }}</span>
                <span>到达上车点</span>
              </span>
            </div>
            <div class="subtitle">
              <span>建议提前5分钟到</span>
              <span class="blue-text">{{ onStopName }}</span>
              <span>等候，以免错过乘车</span>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template #content>
      <RunningSummary :orderInfo="orderInfo" />
    </template>
  </RunningCard>
</template>

<script>
import RunningCard from "./RunningCard.vue";
import RunningSummary from "./RunningSummary.vue";

export default {
  name: "RunningWaiting",
  components: {
    RunningCard,
    RunningSummary,
  },
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
    countdownTime: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    onStopName() {
      const { onStopName = "上车站" } = this.orderInfo || {};
      return onStopName;
    },
    isArrive() {
      const { isArrive } = this.orderInfo || {};
      return isArrive;
    },
    isTimeoutArrive() {
      const { isTimeoutArrive } = this.orderInfo || {};
      return isTimeoutArrive;
    },
    isNear() {
      const { near } = this.orderInfo || {};
      return near === 1;
    },
    onTime() {
      const { onTime } = this.orderInfo || {};
      return onTime;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.running-waiting-header {
  padding: 9px 6px 13px 6px;
  display: flex;
  align-items: center;
  .icon {
    width: 54px;
    height: 54px;
  }
  .right {
    flex: 1;
    margin-left: 4px;
  }
  .status {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
  }

  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    margin-left: 7px;
  }

  .blue-num {
    font-family: DINAlternate, DINAlternate;
    font-weight: 500;
    font-size: 24px;
    color: #006efa;
    line-height: 28px;
  }

  .blue-text {
    color: #006efa;
    font-weight: 500;
  }

  .subtitle {
    margin-top: 3px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
  }
}
</style>
